import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

import { SnRadioFormField } from './components/form-field/radio.form-field';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatRadioModule,
    // Formly
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'radio',
          component: SnRadioFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
  exports: [MatRadioModule],
  declarations: [SnRadioFormField],
})
export class SnFormRadioModule {}
